import * as Yup from 'yup';

const validationSchemaAddLocation = Yup.object().shape({
  ubication: Yup.object().shape({
    ubicationType: Yup.object().nullable().required('Seleccione tipo de ubicación'),
    uunn: Yup.object().nullable().required('Seleccione unidad de negocio'),
    ubication: Yup.object().nullable().required('Ingrese ubicación'),
    event: Yup.object().nullable(),
    team: Yup.object().nullable()
  }),
  imputationObject: Yup.object().shape({
    wells: Yup.array().of(
      Yup.object().shape({
        well: Yup.object()
          .test('wellDuplicate', 'El pozo ya fue agregado', (item, data) => {
            const wellsArray = data?.from[3]?.value?.imputationObject?.wells;
            let error = true;
            const indexInput = Number(data.path.split('[')[1][0]);

            wellsArray?.forEach((well, i) => {
              if (well?.well?.label === item?.label && i !== indexInput) {
                error = false;
              }
            });

            return error;
          })
          .nullable()
          .required('Ingrese un pozo'),
        event: Yup.object()
          .test('eventDiff', 'Ingrese el mismo evento para todos los pozos', (item, data) => {
            const wellsArray = data?.from[3]?.value?.imputationObject?.wells;
            let error = true;
            const indexInput = Number(data.path.split('[')[1][0]);
            // The id belongs to the event
            // map so that value is now wellEventId
            // (which is specific to the Event–Well relationship)
            // wellEventId and event id are always different
            const eventDiff = wellsArray?.some(
              (well, i) => well?.event?.id !== item?.id && i !== indexInput
            );

            if (item?.id) {
              if (eventDiff) {
                error = false;
              }
            }

            return error;
          })
          .nullable()
          .required('Seleccione un evento'),
        team: Yup.object().nullable().required('Seleccione un equipo'),
        imputationType: Yup.object().nullable().required('Seleccione un tipo de imputación'),
        imputationObject: Yup.object().nullable().required('Seleccione un objeto de imputación'),
        state: Yup.string().nullable(),
        budget: Yup.string().nullable(),
        logisticCenter: Yup.string().nullable(),
        socCode: Yup.string().nullable(),
        soc: Yup.array().of(Yup.string()).nullable(),
        add: Yup.bool(),
        editable: Yup.bool()
      })
    )
  })
});

export default validationSchemaAddLocation;
